module.exports = __webpack_public_path__ + "assets/img/17_kaola_100x100.99e445b3.png";